import withRouteStyles from '../../HOC/withRouteStyles';
import LandscapeOverlay from './LandscapeOverlay';

export default withRouteStyles('landscapeOverlay')(LandscapeOverlay);
